<template>
  <div class="row q-px-sm q-py-xs float-right">
    <div class="text-white gt-sm q-px-sm q-pt-md col-12 col-sm-9">
      <div class="text-body2 float-right">{{ username }}</div>
      <div class="text-caption float-right">{{ placement }}</div>
    </div>
    <div>
      <q-avatar
        size="56px"
        font-size="56px"
        class="col-sm-3 float-right"
        @click.stop="toggleDrawer"
      >
        <q-icon :name="avatar" />
      </q-avatar>

      <div class="lt-sm q-mt-sm text-caption text-white  mobile-caption">
        {{ username }}
      </div>
    </div>

    <q-drawer
      side="right"
      behavior="mobile"
      v-model="drawer"
      bordered
      overlay
      :width="300"
    >
      <div class="row q-px-sm q-py-xs">
        <div class="text-primary q-px-sm q-pt-md col-12 col-sm-9">
          <div class="text-body2 float-right">{{ username }}</div>
          <div class="text-caption float-right">{{ placement }}</div>
        </div>
        <q-avatar
          color="primary"
          text-color="white"
          size="56px"
          font-size="56px"
          class="float-right"
          @click.stop="toggleDrawer"
        >
          <q-icon :name="avatar" />
        </q-avatar>
      </div>
      <q-card class="absolute full-width " style="height: calc( 100% - 64px - 50px  )">
        <q-tab-panels
          v-model="tab"
          swipeable
          infinite
          animated
          class="fit text-primary"
        >
          <q-tab-panel name="user">
            <div class="text-h6">Usuário</div>
            <q-btn @click="logout">sair</q-btn>
          </q-tab-panel>

          <q-tab-panel name="apps">
            <div class="text-h6">Aplicativos</div>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </q-tab-panel>

          <q-tab-panel name="conf">
            <div class="text-h6">Configurações</div>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </q-tab-panel>
        </q-tab-panels>

        <q-tabs
          v-model="tab"
          class="bg-primary fixed-bottom"
          align="justify"
          narrow-indicator
        >
          <q-tab name="user" label="Usuário" />
          <q-tab name="apps" label="Apps" />
          <q-tab name="conf" label="Config" />
        </q-tabs>
      </q-card>
    </q-drawer>
  </div>
</template>

<script setup>
import { useUserStore } from "@/store/user-store";
import { computed, ref } from "vue";

const userStore = useUserStore();
const logout = () => userStore.logout()
const username = computed(() => userStore.user);
const placement = computed(() => userStore.placement);
const toggleDrawer = () =>
  (userStore.drawerExpanded = !userStore.drawerExpanded);
const drawer = computed({
  get: () => userStore.drawerExpanded,
  set: v => (userStore.drawerExpanded = v)
});
const tab = ref("user");
const avatar = computed(() => userStore.avatar || "account_circle");

</script>
